'use client'

import { useMemo } from 'react'
import { composeClasses } from '@wiggot/utils'
import { Modal } from '@dd3tech/wiggui/Modal'
import { Text } from '@dd3tech/wiggui/Text'
import { Button } from '@dd3tech/wiggui/Button'
import { useSession } from '@wiggot/auth/hooks/useSession'
import PlanStarterImg from './svg/plan-starter'

const ModalExpireTrial = () => {
  const { profile, token, roles } = useSession()
  const gotoExternalPath = () => {
    window.location.href = `${window.location.origin}/shop`
  }

  const isShow = useMemo(() => {
    if (window.location.pathname.includes('dominio-personalizado-faq')) {
      return false
    } else if (profile && roles) {
      const { planType, primeType, trialUsed, fullPlanUsed } = profile
      return Boolean(
        token &&
          !planType &&
          !primeType &&
          trialUsed &&
          !fullPlanUsed &&
          !roles.ADVANCED &&
          !roles.STARTER
      )
    }
    return false
  }, [profile, roles, token])

  return (
    <Modal
      isOpen={isShow}
      className="w-full md:w-[524px] fixed md:static bottom-0 !bg-surface-bg-black"
      onClose={() => console.log('no closed')}
      isResponsive={false}
      enableBgBlur
    >
      <Modal.Header className="relative flex justify-between items-center w-full h-12 p-7 border-b border-b-[#2B3946]">
        <p className={composeClasses('text-body-xl  w-full text-white')}>
          Tu prueba del Plan Avanzado ha terminado
        </p>
      </Modal.Header>
      <Modal.Body className="flex flex-col gap-6 w-full justify-center items-center">
        <PlanStarterImg />
        <div className="flex flex-col items-center text-center">
          <Text className="text-body-m font-normal text-center text-white">
            Para continuar usando tu cuenta, adquiere un plan en nuestra tienda.
          </Text>
        </div>
      </Modal.Body>
      <Modal.Footer className="flex justify-center gap-3 w-full px-6 py-2 border-t border-t-[#2B3946] border-strokes">
        <Button className="w-full" variant="primary" onClick={gotoExternalPath}>
          Ir a la tienda
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ModalExpireTrial
